<template>
  <div>
    <Loading v-show="showLoading2" />

    <div class="container">
      <v-flex xs12 sm6 d-flex>
        <br />
      </v-flex>

      <!-- <h2>Sensores</h2> -->
      <v-card class="card main">
        <br />
        <br />
        <div
          v-if="ready"
          id="evvos-agriculture"
          style="width:100%; padding-top:20px; height:600px;"
        />
        <br />
        <p class="text-xs-center">
          ***Selecciona el sector que quieres visualizar
        </p>
      </v-card>
      <br />
      <br />
    </div>
  </div>
</template>

<script>
const Loading = () => import("../components/resources/Loading.vue");
// import moment from "moment-timezone";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      devices: [],
      showLoading2: true,
      substrates: {
        legro: 28,
        coco: 18,
      },
      substrates2: {
        legro: 40.45,
        coco: 18,
      },
      phenology: {
        vegetativa: 1,
        floracion: 1.25,
      },
      series: [],
      series2: [],
      historic: null,
      modal: null,
      select: null,
      select2: null,
      date: null,
      date2: null,
      date3: null,
      date4: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      ready: true,
      ready2: false,
      chart2: null,
    };
  },
  computed: {
    devicesX() {
      return this.$store.getters.proDevices;
    },
  },
  watch: {
    devicesX() {
      while (this.chart2.series.length > 0) this.chart2.series[0].remove(true);
      this.fetchData2();
      this.ready = true;
    },
  },
  mounted() {
    this.showLoading2 = false;
    this.fetchData2();
  },
  beforeUpdate() {
    setTimeout(() => {
      this.showLoading2 = false;
    }, 2500);
  },
  methods: {
    parsePH(x) {
      x.humidity = x.humidity / 1000;
      let pH = -7.2 * x.humidity + 15.509;
      return pH;
    },
    fetchData2: async function() {
      console.log("Mounted sensors", this.$store.state.proDevices);
      this.showLoading2 = true;

      this.populateChart2();
      let date = new Date().toISOString().substr(0, 10);
      let yesterday = new Date(new Date(date).setHours(0));
      let today = new Date(new Date(date).setHours(0));

      today.setDate(today.getDate() + 2);

      let yAxis = 20;

      await this.$store.state.devices.forEach(async (element) => {
        console.log(element);
        let params = {
          sigfoxDeviceId: element.sigfoxId,
          startDate: yesterday,
          endDate: today,
        };

        await this.$axios
          .get(
            `https://listener.rabiahostal.com.mx/api/message/get-by-device`,
            {
              params,
            }
          )
          .then((response) => {
            let payload = {
              name: element.name,
              data: [],
              date: [],
            };

            let res = response.data;

            let newArr = res.map((x) => {
              return [new Date(x.date).getTime(), this.parsePH(x)];
            });

            let dates = res.map((x) => {
              return x.date;
            });

            payload.data.push(newArr);
            payload.date.push(dates);

            console.log(newArr);
            console.log(dates[0]);
            console.log(new Date(dates[0]));

            this.series2.push(payload);
            this.chart2.addSeries(
              {
                data: newArr,
                name: element.name,
                visible: false,
              },
              false
            );

            yAxis += yAxis;
            this.chart2.redraw();
          });
        this.modal = true;
      });
    },
    populateChart2() {
      this.chart2 = this.$Highcharts.chart("evvos-agriculture", {
        time: {
          timezoneOffset: +5 * 60,
        },
        chart: {
          type: "areaspline",
          zoomType: "xy",
        },
        legend: {
          enabled: true,
          verticalAlign: "bottom",
          align: "right",
          y: 0,
        },
        title: {
          text: "pH",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          type: "datetime",
          labels: {
            format: "{value: %d %b %Y}",
          },
        },
        yAxis: {
          min: 0,
          max: 14,
          title: {
            text: "",
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.container {
  height: 1100px !important;
}

.main {
  height: 800px;
}
</style>
